/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import CustomPopup from "../../../Common/components/CustomPopup/CustomPopup";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import { selectEventsData, updateConfiguration } from "../../../Common/store/slices/common";
import { logEvent } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";
import AxisComponent from "../../../Retrofit/components/Axes/AxisComponent";
import {
  addNewAxis,
  DEFAULT_SIZING,
  selectAxesToDisplay,
  selectNewAxisMode,
  selectRetrofitConfiguration,
  selectShowAxisPopup,
  selectSizingSelected,
  setAxesToDisplay,
  setConfigData,
  setFiltersPopupOpened,
  setIsSizingSelected,
  setNewAxisMode
} from "../../../Retrofit/store/slices/retrofit";
import AxisRecap from "../../components/Devices/AxisRecap";
import RetrofitSizing from "../../Sizing/RetrofitSizing";
import FiltersPopup from "./FiltersPopup";

const Specify = () => {
  const YES_SIZING = "yes_sizing";
  const NO_SIZING = "no_sizing";
  const configuration = useSelector(selectRetrofitConfiguration);
  const eventsData = useSelector(selectEventsData);
  const axestoDisplay = useSelector(selectAxesToDisplay);
  const isSizingSelectedFromRedux = useSelector(selectSizingSelected);
  const newAxisMode = useSelector(selectNewAxisMode);
  const isMobile = useCheckMobileScreen();
  const [addAxisClicked, setAddAxisClicked] = useState(configuration?.configData.axes?.length === 0);
  const [showSizing, setShowSizing] = useState(false);
  const [isSizingSelected, setSizingSelected] = useState(true);
  const showAxisPopup = useSelector(selectShowAxisPopup);

  const dispatch = useDispatch();

  const handleSizingYesNo = (event) => {
    setSizingSelected(event.target.value === YES_SIZING ? true : false);
  };

  const handleContinueSizingPopup = () => {
    setAddAxisClicked(false);
    if (!isSizingSelected) {
      addAxis();
    } else {
      dispatch(
        setConfigData({
          ...configuration.configData,
          sizing: DEFAULT_SIZING
        })
      );
    }
    setSizingSelected(true); // reset to default
    setShowSizing(isSizingSelected);
    dispatch(setIsSizingSelected(isSizingSelected));
  };

  const addAxis = () => {
    dispatch(addNewAxis());
    dispatch(updateConfiguration());
    dispatch(setNewAxisMode(true));
    if (axestoDisplay === "with_bundle") {
      dispatch(setAxesToDisplay("all"));
    }
    logEvent(eventsData.locale, eventsData.types.addAxis, eventsData.tags.specifySelectRecap, configuration?.configId);
  };

  useEffect(() => {
    dispatch(setFiltersPopupOpened(false));
    setAddAxisClicked(true);
  }, []);

  const isProductionEnv = () => {
    return process.env.REACT_APP_API_URL === "https://www.se.com/ww/confsdl/msizer-api";
  };

  const handleAddAxisClick = () => {
    if (isProductionEnv()) {
      addAxis();
    } else {
      setAddAxisClicked(true);
    }
  };

  return (
    <div className={showAxisPopup ? "hidden" : ""}>
      {!isSizingSelectedFromRedux && (
        <div className="axes-recap-wrapper flex flex-col space-y-3 mt-2 mb-32 md:mb-2">
          {configuration?.configData.axes.map((axis, index) => {
            const bundleSelected = axis.bundle.motorReference !== null && axis.bundle.motorReference !== undefined;
            const axisState = configuration?.configData?.axes.find((a) => a.id === axis.id)?.axisState;
            // check axes to display
            if (
              (axestoDisplay === "with_bundle" && !bundleSelected) ||
              (axestoDisplay === "without_bundle" && bundleSelected)
            ) {
              return null;
            }
            // if the bundle is not selected, show AxisComponent, otherwise show AxisRecap
            if (!bundleSelected && !axisState?.applicationDataFiltersApplied) {
              return (
                <AxisComponent
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  axisId={axis.id}
                  // setFiltersPopupActiveTab={setFiltersPopupActiveTab}
                  minimal={false}
                  newAxis
                />
              );
            }
            return (
              (!newAxisMode || !isMobile) && (
                <AxisRecap
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  axis={axis}
                />
              )
            );
          })}
        </div>
      )}
      {isMobile && !newAxisMode && (
        <button
          type="button"
          onClick={() => setAddAxisClicked(true)}
          className="fixed shadow bottom-20 right-6 inline-flex space-x-1 py-1 px-3 items-center justify-center rounded-full border-secondary border-[1px] bg-white text-secondary"
        >
          <MsxIcons name="add-flat" />
          <div className="flex items-center text-sm font-medium">{t("msizer.ui.axis")}</div>
        </button>
      )}
      {!isMobile && !showSizing && (
        <div
          id="retrofit-specify-button-add-axis"
          role="button"
          tabIndex={0}
          onClick={handleAddAxisClick}
          className="flex mb-20 bg-gray-50 border-[1px] border-solid border-gray-200 p-2 items-center justify-center space-x-1 text-secondary
 cursor-pointer transition-all duration-75 hover:bg-gray-100 select-none"
        >
          <IoIosAddCircleOutline className="text-base" />
          <span className=" text-sm">{t("msizer.ui.specify.add_axis_button_text")}</span>
        </div>
      )}
      <FiltersPopup />
      {addAxisClicked && !isProductionEnv() && (
        <div>
          <CustomPopup
            title="Size my solution"
            titleStyle="flex items-start"
            opened={addAxisClicked}
            onClose={() => {
              setSizingSelected(true); // reset to default
              setAddAxisClicked(false);
            }}
            cancelAction={() => {
              setSizingSelected(true); // reset to default
              setAddAxisClicked(false);
            }}
            continueAction={() => handleContinueSizingPopup()}
            continueLabel="Create new Axis"
            cancelLabel="Back"
          >
            <div className="ml-28 flex flex-col items-start space-y-3">
              <div className="flex space-x-2 items-center">
                <input
                  checked={isSizingSelected}
                  type="checkbox"
                  value={YES_SIZING}
                  name="sizing-radio"
                  onChange={handleSizingYesNo}
                  className={`w-5 h-5 appearance-none border-1 rounded-full cursor-pointer transition-all duration-100 checked:bg-primary focus:ring-primary ${
                    isSizingSelected ? "bg-primary" : "bg-transparent"
                  }`}
                />
                <button
                  type="button"
                  onClick={() => handleSizingYesNo({ target: { value: YES_SIZING, checked: true } })}
                  className="text-base"
                  htmlFor="yes_sizing"
                >
                  Yes, I need help to size my solution
                </button>
              </div>
              <div className="flex space-x-2 items-center">
                <input
                  checked={!isSizingSelected}
                  type="checkbox"
                  value={NO_SIZING}
                  name="sizing-radio"
                  onChange={handleSizingYesNo}
                  className={`w-5 h-5 appearance-none border-1 group-hover:border-2 group-hover:border-primary rounded-full cursor-pointer transition-all duration-100 checked:bg-primary focus:ring-primary ${
                    !isSizingSelected ? "bg-primary" : "bg-transparent"
                  }`}
                />
                <button
                  type="button"
                  onClick={() => handleSizingYesNo({ target: { value: NO_SIZING, checked: true } })}
                  className="text-base"
                  htmlFor="no_sizing"
                >
                  No, I don't need help with sizing
                </button>
              </div>
            </div>
          </CustomPopup>
        </div>
      )}
      <RetrofitSizing showSizing={showSizing} setShowSizing={setShowSizing} />
    </div>
  );
};

export default Specify;
